// extracted by mini-css-extract-plugin
export default {"badges":"ClientPage_badges__RYARS","licenseLogo":"ClientPage_licenseLogo__OWPYJ","ageLogo":"ClientPage_ageLogo__qgHNn"};